import SearchAreaInput from './search-area-input-view'
export default SearchAreaInput
